import axiosInstance from '../api/axiosInstance';

/**
 * userService — All User Management API calls
 *
 * These are plain async functions. React Query hooks call these
 * functions — keeping API logic separate from UI logic.
 *
 * Endpoints (adjust paths to match your backend):
 *  GET    /users         → list all users
 *  GET    /users/:id     → get one user
 *  POST   /users         → create a user
 *  PUT    /users/:id     → update a user
 *  DELETE /users/:id     → delete a user
 */

// Get all users
export const getUsers = (params) => {
  return axiosInstance.get('/users', { params }).then((res) => res.data);
};

// Get a single user by ID
export const getUser = (id) => {
  return axiosInstance.get(`/users/${id}`).then((res) => res.data);
};

// Create a new user
export const createUser = (data) => {
  return axiosInstance.post('/users', data).then((res) => res.data);
};

// Update an existing user
export const updateUser = (id, data) => {
  return axiosInstance.put(`/users/${id}`, data).then((res) => res.data);
};

// Delete a user
export const deleteUser = (id) => {
  return axiosInstance.delete(`/users/${id}`).then((res) => res.data);
};
